/**
 * Calibration sweep UI: a small status banner while it runs, then a result
 * panel with the JSON in a text box and a copy button. The text box is the
 * fallback where clipboard access is blocked (some iOS contexts).
 */

export interface BenchPanel {
  setStatus(text: string): void;
  /** Show any JSON-serializable result with a title. */
  showResult(result: object, title?: string): void;
}

export function createBenchPanel(): BenchPanel {
  const banner = document.createElement('div');
  banner.className = 'panel bench-banner';
  document.body.appendChild(banner);

  return {
    setStatus(text: string): void {
      banner.textContent = text;
    },
    showResult(
      result: object,
      titleText = 'Calibration sweep finished. Copy this and paste it back.',
    ): void {
      banner.remove();
      const json = JSON.stringify(result, null, 2);
      const panel = document.createElement('div');
      panel.className = 'panel bench-result';
      const title = document.createElement('div');
      title.className = 'controls-title';
      title.textContent = titleText;
      const box = document.createElement('textarea');
      box.readOnly = true;
      box.value = json;
      box.addEventListener('focus', () => {
        box.select();
      });
      const row = document.createElement('div');
      const copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'hud-copy';
      copy.textContent = 'Copy JSON';
      copy.addEventListener('click', () => {
        navigator.clipboard.writeText(json).then(
          () => {
            copy.textContent = 'Copied';
          },
          () => {
            box.focus();
            copy.textContent = 'Copy blocked: text selected, copy manually';
          },
        );
      });
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'hud-copy';
      close.textContent = 'Close';
      close.addEventListener('click', () => {
        panel.remove();
      });
      row.append(copy, ' ', close);
      panel.append(title, box, row);
      document.body.appendChild(panel);
    },
  };
}
